import * as React from 'react';

import PlayerInfoRow from '../Elements/PlayerInfoRowElement';
import { getFlagUrl } from '../../api/assetUrls';
import useTranslation from '../../hooks/useTranslation';

import('./LiveStatisticBarStyles.scss')   



const LiveStatisticBarPresentation = (props:any) => {
    let barLeft = statisticBar('left', props.servicePointsWon, props);
    let barRight = statisticBar('right', props.serviceGamesWon, props);

    // in case of a tieBreak we show slightly different data
    if (props.isTiebreak) {
        //barLeft  = statisticBar('left', props.servicePointsWon, props);
        barRight = statisticBar('right', props.tiebreakGamesWon, props);
    }

    return (
        <div className={"sr-grid sr-align-center liveStatisticBar " + props.player.isHomeOrAway +
        " " + isOverlayVisible(props.overlayIsVisible)}>
            <div className="sr-cell">
                <div className="sr-content liveStatisticBar-left">
                    {barLeft}
                </div>
            </div>
            <div className="sr-cell sr-xs-1-6 liveStatisticBar-center-flex">
                <div className="sr-content liveStatisticBar-center">
                    <PlayerInfoRow  flagUrl = { getFlagUrl( props.baseUrl, props.clientid, props.player.playerId ) }
                                    playerAbbreviationName = { props.player.displayName } />
                </div>
            </div>
            <div className="sr-cell">
                <div className="sr-content liveStatisticBar-right">
                    {barRight}
                </div>
            </div>
        </div>
    );
};


const statisticBar = (direction:string, statsObject:any, props:any) => {
    let barLength = statsObject.current * 100 / statsObject.total;

    // if we devide 0/0 the result is NaN - in that case we just return 0 so that no bar is rendered
    if (isNaN(barLength)) {
        barLength = 0;
    }

    return (
        <div>
            <div className="liveStatisticBar-content">
                {
                    direction == 'right' ?
                        <StatisticBarRightOriented statsObject={statsObject} isTiebreak={props.isTiebreak} />
                    :
                        <StatisticBarLeftOriented statsObject={statsObject} />
                }
            </div>
            <div className="liveStatisticBar-bar">
                <div style={{width:`${barLength}%`}}></div>
            </div>
        </div>
    );
};

const StatisticsBarValue = ( props: { statsObject: any } ) => {
    return (
        <div className="liveStatisticBar-value">
            <div>
                <span className="liveStatisticBar-highlighted">
                    {props.statsObject.current}
                </span>
                /{props.statsObject.total}
            </div>
        </div>
    )
}


const StatisticBarLeftOriented = (props: { statsObject: any }) => {
    const last10ServicePointsText = useTranslation('LiveStatisticsBar_Last10ServicePoints');
    return (
        <div>
            <div className="liveStatisticBar-headline">
                {last10ServicePointsText}
            </div>
            <StatisticsBarValue statsObject={props.statsObject} />
        </div>
    );
};


const StatisticBarRightOriented = (props: { statsObject: any, isTiebreak: boolean }) => {
    // depending on tie break or not set static text to be translated
    const last10TieBreaksText = useTranslation('LiveStatisticsBar_Last10TieBreaks');
    const lastServiceGamesText = useTranslation('LiveStatisticsBar_LastServiceGames');

    return (
        <div>
            <StatisticsBarValue statsObject={props.statsObject} />
            <div className="liveStatisticBar-headline">
                {props.isTiebreak ? last10TieBreaksText : lastServiceGamesText}
            </div>
        </div>
    );
};

// returns a stric hidden if the boolean is true
const isOverlayVisible = (visible:boolean) => visible ? 'hidden' : '';

export default LiveStatisticBarPresentation;